"use client";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { SANS_FONT_STACK } from "@portal/app/_components/theme/options/typography";

export function PageReassurance({ text }: { text: string }) {
  if (!text.trim()) return null;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "baseline",
        gap: "6px",
        justifyContent: "center",
        textAlign: "center",
        "@media (min-width: 768px)": { justifyContent: "flex-start", textAlign: "left" },
        color: "#2b3242",
      }}
    >
      <FontAwesomeIcon icon={faLock} aria-hidden="true" />
      <Typography
        sx={{
          fontFamily: SANS_FONT_STACK,
          color: "#2b3242",
          fontSize: "15px",
          lineHeight: "28px",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
